import React, { useState, useEffect } from 'react';
import { useTheme } from '../Providers/ThemeContext';
import styles from './WispyStars.module.css';

interface WispyStar {
  id: number;
  x: number; // percentage from left
  y: number; // percentage from top
  opacity: number;
  fadeDirection: 'in' | 'out';
  duration: number; // seconds for full fade cycle
  delay: number; // initial delay before starting
}

function WispyStars() {
  const { theme } = useTheme();
  const [stars, setStars] = useState<WispyStar[]>([]);

  useEffect(() => {
    // Generate initial set of wispy stars
    const generateStars = () => {
      const newStars: WispyStar[] = [];
      const numStars = 8; // Reduced from 15 to 8 for better performance

      for (let i = 0; i < numStars; i++) {
        newStars.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          opacity: 0,
          fadeDirection: Math.random() > 0.5 ? 'in' : 'out',
          duration: 3 + Math.random() * 4, // 3-7 seconds per cycle (slower = less GPU work)
          delay: Math.random() * 15, // 0-15 seconds initial delay
        });
      }

      setStars(newStars);
    };

    generateStars();

    // Update star states periodically - DISABLED for performance
    // Stars will stay in their initial positions
    // const interval = setInterval(() => {
    //   setStars(prevStars =>
    //     prevStars.map(star => {
    //       // Randomly change position occasionally (15% chance)
    //       if (Math.random() < 0.15) {
    //         return {
    //           ...star,
    //           x: Math.random() * 100,
    //           y: Math.random() * 100,
    //           duration: 2 + Math.random() * 3, // New random duration
    //           delay: Math.random() * 5, // Shorter delay for repositioned star
    //         };
    //       }
    //       return star;
    //     })
    //   );
    // }, 5000); // Reposition some stars every 5 seconds

    // return () => clearInterval(interval);
  }, []);

  return (
    <div className={`${styles.wispyStars} ${theme === 'dark' ? styles.dark : styles.light}`}>
      {stars.map(star => (
        <div
          key={star.id}
          className={`${styles.wispyStar} ${theme === 'dark' ? styles.starElement : styles.cloudElement}`}
          style={{
            left: `${star.x}%`,
            top: `${star.y}%`,
            animationDuration: `${star.duration}s`,
            animationDelay: `${star.delay}s`,
          }}
        />
      ))}
    </div>
  );
}

export default WispyStars;